import { createFileRoute } from "@tanstack/react-router";
import { Tv6UltraPage } from "@/components/products/Tv6UltraPage";
import { tv6UltraSeo } from "@/lib/page-seo";
import heroLifestyle from "@/assets/products/tv6-ultra/hero-lifestyle-clean.jpg";

export const Route = createFileRoute("/products/inext-tv6-ultra")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) =>
    tv6UltraSeo(loaderData?.href ?? "/products/inext-tv6-ultra", heroLifestyle),
  component: Tv6UltraPage,
});
